export class GameVars {

    public static winners:  {[id: string]: number}; 
    public static points:  {[id: string]: number}; 
    public static winnerCount: number;

    public static gameLoaded: boolean;
    public static typeAd: string;

    public static currentScene: Phaser.Scene;

    public static scaleX: number;
    public static scaleY: number;
    public static gameSpeed: number;
    public static gameData: GameData;
    public static language: string;
    public static paused: boolean;
    public static callValue: number;
    public static raiseValue: number;
    public static betValue: number;
    public static initialChips: number;

    public static playerId: string;

    public static botsInfo: BotsInfo;

    public static allin: boolean;
    public static allinSince: string;
    public static gameOver: boolean;

    // logic values
    public static gameState: PokerGameState;
    public static cards: string[];
    public static currentTurn: number;
    public static lastTurn: number;
    public static firstLoop: boolean;
    public static blindsPosition: number;

    // lo referente al juegod de higher and lower
    public static hiLoScore: number;
    public static hiLoRemainingCards: number;
    public static hiLoHearts: number;
    public static hiLoExtraHearts: number;

    public static areValidDomains(domains: string[]): boolean {

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (window.location.hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (document.referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {
                if (document.referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static cardFrameName(name: string): string {

        let newNum = name[0];

        switch (newNum) {
            case "T":
                newNum = "10";
                break;
            case "J":
                newNum = "11";
                break;
            case "Q":
                newNum = "12";
                break;
            case "K":
                newNum = "13";
                break;
            case "A":
                newNum = "1";
                break;
            default:
                break;
        }
        
        return name[1] + "_" + newNum;
    }
}
